import cn from "classnames";

import styles from "./map-marker-icon.module.scss";

interface MapMarkerIconInterface {
  color: string;
  probability: number;
  isActive?: boolean;
  markerName: string;
}

const ACTIVE_MARKER_COLOR = "#09090B";

const MapMarkerIcon = ({
  color,
  isActive,
  probability,
  markerName
}: MapMarkerIconInterface) => {
  return (
    <div
      className={cn(styles["marker"], { [styles["marker--active"]]: isActive })}
      data-testid="marker"
    >
      {markerName && (
        <span
          style={{ backgroundColor: isActive ? ACTIVE_MARKER_COLOR : color }}
          className={cn(styles["marker__text"], styles["marker__mine-name"], {
            [styles["marker__only-mine-name"]]: !probability
          })}
        >
          {markerName}
        </span>
      )}
      {probability && (
        <span
          style={{ backgroundColor: isActive ? ACTIVE_MARKER_COLOR : color }}
          className={cn(styles["marker__text"], styles["marker__probability"])}
        >
          {typeof probability === "string"
            ? probability
            : `${Math.round(probability * 100)}%`}
        </span>
      )}
    </div>
  );
};
export default MapMarkerIcon;
